import React,{ useEffect } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery';
import ScrollToTop from "react-scroll-to-top";

import Logo2 from '../../images/logon.png';
import Logo from '../../images/logoMain.png';


function HeaderThree() {

  useEffect(()=>{
    //SubMenu Dropdown Toggle
      if ($('.menu-area li.menu-item-has-children ul').length) {
        $('.menu-area .navigation li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');

      }

      //Mobile Nav Hide Show
      if ($('.mobile-menu').length) {

        var mobileMenuContent = $('.menu-area .push-menu').html();
        $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

        //Dropdown Button
        $('.mobile-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
          $(this).toggleClass('open');
          $(this).prev('ul').slideToggle(500);
        });


        $('.menu-backdrop, .mobile-menu .close-btn').click (()=>{
          $('body').removeClass('mobile-menu-visible');
        })


        //Menu Toggle Btn
        $('.mobile-nav-toggler').on('click', function () {
          $('body').addClass('mobile-menu-visible');
        });
      }
      

  },[]);
  useEffect(()=>{
    $(window).on('scroll', function () {
      var scroll = $(window).scrollTop();
      if (scroll < 245) {
        $("#sticky-header").removeClass("sticky-menu");
        $('.scroll-to-target').removeClass('open');
    
      } else {
        $("#sticky-header").addClass("sticky-menu");
        $('.scroll-to-target').addClass('open');
      }
    });
    
  },[])
  return (

	 <header className="third-header-bg">
     <ScrollToTop smooth top="500" color="#000" />
          <div className="bg" />
          <div className="container custom-container">
            <div className="header-top-area t-header-top-area d-none d-lg-block">
              <div className="row">
                <div className="col-sm-6">
                  <div className="header-top-social">
                    <ul>
                      <li>Follow</li>
                      <li><a href="https://twitter.com/cipherem" target = "__blank" style={{'backgroundColor': 'white', 'background-image': 'none'}}><i className="fab fa-twitter" style={{'color': 'black'}} /></a></li>
                      <li><a href="https://t.me/cipherem" target = "__blank" style={{'backgroundColor': 'white', 'background-image': 'none'}}><i className="fab fa-telegram" style={{'color': 'black'}}  /></a></li>
                      <li><a href="https://medium.com/@press_62958" target = "__blank" style={{'backgroundColor': 'white', 'background-image': 'none'}}><i className="fab fa-medium" style={{'color': 'black'}}  /></a></li>
                      <li><a href="https://youtube.com/channel/UCjzo5bbhBfj7BWmTtWBjqkQ" target = "__blank" style={{'backgroundColor': 'white', 'background-image': 'none'}}><i className="fab fa-youtube" style={{'color': 'black'}}  /></a></li>
                      <li><a href="https://www.linkedin.com/company/cipherem" target = "__blank" style={{'backgroundColor': 'white', 'background-image': 'none'}}><i className="fab fa-linkedin" style={{'color': 'black'}}  /></a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="header-top-login">
                    <ul>
                      <li><Link to="/register"><i className="far fa-edit"  style={{'color': 'white'}}  />Register</Link></li>
                      <li className="or">or</li>
                      <li><Link to="/login"><i className="far fa-edit"  style={{'color': 'white'}} />sign in</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div id="sticky-header" className="menu-area">
            <div className="container custom-container">
              <div className="row">
                <div className="col-12">
                 <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
                  <div className="main-menu  menu-style-two">
                    <nav>
                      <div className="logo d-block d-lg-none">
                        <a href="/"><img src={Logo} alt="Logo" style={{'width': '50%', 'height': 'auto'}} /></a>
                      </div>
                      <div className="navbar-wrap d-none d-lg-flex">
                        <ul className="left">
                          <li><Link to="/home">Home</Link></li>
                          <li><Link to="/#">About</Link></li>
                          <li><Link to="/#">Gitbook</Link></li>
                          <li><Link to="/#">Exchange</Link></li>
                        </ul>
                        <div className="logo">
                          <Link to="/home-three"><img src={Logo2} style={{'width': '262px', 'height': 'auto'}} alt="Logo" /></Link>
                        </div>
                        <ul className="right">
                          
                        <li><Link to="/#">Team</Link></li>
                          <li><Link to="/#">Staking</Link></li>
                          <li><Link to="/#">Blog</Link></li>
                          <li><Link to="/#">Contact</Link></li>
                        </ul>
                      </div>
                      <div className="header-action">
                        <ul>
                           {/* <li className="header-search"><a href="/#" data-toggle="modal" data-target="#search-modal"><i className="fas fa-search" /></a></li> */}
                        </ul>
                      </div>
                    </nav>
                  </div>
                  <div className="mobile-menu-wrap main-menu d-block d-lg-none" >
                    <nav>
                      <div  className="navbar-wrap push-menu" >
                        <ul className="navigation" style={{marginTop: "5rem"}}>
                          {/* <li><Link to="/">Home</Link></li> */}
                          {/* <li><Link to="/#">About</Link></li> */}
                          <li><Link to="/#">Gitbook</Link></li>
                          <li><Link to="/#">Exchange</Link></li>

                          {/* <li><Link to="/#">Team</Link></li> */}
                          <li><Link to="/#">Staking</Link></li>
                          {/* <li><Link to="/#">Blog</Link></li> */}
                          {/* <li><Link to="/#">Contact</Link></li> */}
                          <li><Link to="/register">Register</Link></li>
                          <li><Link to="/login">LogIn</Link></li>
                          
                          
                        </ul>
                      </div>
                    </nav>
                  </div>
                    {/* mobile-menu           */}
                  <div className="mobile-menu">
                      <nav className="menu-box">
                          <div className="close-btn"><i className="fas fa-times" /></div>
                          {/* <div className="nav-logo"><Link to="/"><img src={Logo2} alt="" title='true' /></Link>
                          </div> */}
                          <div className="menu-outer">
                        
                          </div>
                          <div className="social-links">
                            <ul className="clearfix">
                              <li><a href="https://t.me/cipherem" target = "__blank"><i className="fab fa-telegram" /></a></li>
                              <li><a href="https://twitter.com/cipherem" target = "__blank"><i className="fab fa-twitter" /></a></li>
                              <li><a href="https://medium.com/@press_62958" target = "__blank"><i className="fab fa-medium" /></a></li>
                              <li><a href="https://youtube.com/channel/UCjzo5bbhBfj7BWmTtWBjqkQ" target = "__blank"><i className="fab fa-youtube" /></a></li>
                              <li><a href="https://www.linkedin.com/company/cipherem" target = "__blank"><i className="fab fa-linkedin" /></a></li>
                            </ul>
                          </div>
                      </nav>
                </div>
                <div className="menu-backdrop" />
               </div>
                {/* Modal Search */}
                <div className="modal fade" id="search-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <form>
                        <input type="text" placeholder="Search here..." />
                        <button><i className="fa fa-search" /></button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-bottom-bg" />
        </header>
  )
}

export default HeaderThree